import React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { If, Then } from "react-if";

import CustomNotification from "../../../../components/notification";
import LoadingSpinner from "../../../../components/loadingSpinner";
import SearchBar from "./searchBar";
import ConfirmPopup from "../../../../components/confirmPopup";
import { arrowBottom } from "../../../../assets/svg";
import "./styles.scss";

const SidenavInner = (props) => {
  const {
    sidenavProps,
    sidenavState,
    showTabsDropdown,
    tabing,
    wrapperRef,
    handleDropdown,
    handleSearch,
    handleSidebarClear,
    numbersRef,
    loadMoreUsers,
    listingLiveAgentChats,
    checkClear,
    handleConfirmPopupClear,
    handleOnClear,
  } = props;

  const { liveAgentChatCount, liveAgentChat, unreadReducer } = sidenavProps;

  const {
    showDropdown,
    hasMore,
    activeTab,
    search,
    isLoadingActive,
    removeListPopup,
  } = sidenavState;

  const { unreadMessage } = unreadReducer;

  const {
    customPopupMessage,
    messageType,
    message,
  } = sidenavProps.popupReducer;

  const { isFetchingChatList } = liveAgentChat;

  return (
    <>
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      {removeListPopup && (
        <ConfirmPopup
          isDelete
          titleMessage="Confirm to Clear"
          handleCancel={handleConfirmPopupClear}
          handleDelete={handleOnClear}
          isVisible={removeListPopup}
          submitButtonText="Yes"
          cancelButtonText="No"
          message="Are you sure you want to clear this list?"
        />
      )}

      <div className="chat-sidebar-container">
        <div className="chat-sidebar-tabs">
          <div
            className={`sidebar-nav-item ${activeTab === "1" ? "active" : ""}`}
            onClick={() => tabing("1", true)}
          >
            Active Chats
            <span className={`${unreadMessage ? "notification-icon" : ""}`} />
            {liveAgentChatCount.active !== undefined &&
              liveAgentChatCount.active !== 0 && (
                <span className="badge-count">{`(${
                  liveAgentChatCount.active
                })`}</span>
              )}
          </div>

          <div
            className={`sidebar-nav-item ${activeTab === "2" ? "active" : ""}`}
            onClick={() => tabing("2", true)}
          >
            Unclaimed
            {liveAgentChatCount.unclaimed !== undefined &&
              liveAgentChatCount.unclaimed !== 0 && (
                <span className="badge-count">{`(${
                  liveAgentChatCount.unclaimed
                })`}</span>
              )}
          </div>

          <div
            className={`sidebar-nav-item ${activeTab === "3" ? "active" : ""}`}
            onClick={() => tabing("3", true)}
          >
            Closed Chats
            {liveAgentChatCount.closed !== undefined &&
              liveAgentChatCount.closed !== 0 && (
                <span className="badge-count">{`(${
                  liveAgentChatCount.closed
                })`}</span>
              )}
          </div>

          <span
            as="button"
            className="side-nav-items-button"
            onClick={showTabsDropdown}
          >
            {arrowBottom}

            <If condition={showDropdown}>
              <Then>
                <section className="tabs-dropdown" ref={wrapperRef}>
                  <div
                    className={`dropdown-nav-item ${
                      activeTab === "1" ? "active" : ""
                    }`}
                    onClick={() => {
                      tabing("1", true);
                      handleDropdown();
                    }}
                  >
                    Active Chats
                  </div>

                  <div
                    className={`dropdown-nav-item ${
                      activeTab === "2" ? "active" : ""
                    }`}
                    onClick={() => {
                      tabing("2", true);
                      handleDropdown();
                    }}
                  >
                    Unclaimed
                  </div>

                  <div
                    className={`dropdown-nav-item ${
                      activeTab === "3" ? "active" : ""
                    }`}
                    onClick={() => {
                      tabing("3", true);
                      handleDropdown();
                    }}
                  >
                    Closed Chats
                  </div>
                </section>
              </Then>
            </If>
          </span>
        </div>

        <div className="chat-sidebar-content">
          <SearchBar
            search={search}
            handleOnChange={handleSearch}
            handleOnClear={handleSidebarClear}
            showClear={checkClear(activeTab)}
          />
          <div
            className={`tab-content-pane my-active-tab ${
              activeTab ? "active" : ""
            }`}
          >
            {isFetchingChatList && (
              <LoadingSpinner
                type="small"
                relative
                customClassName="without-background"
              />
            )}

            <div className="phone-numbers-container" ref={numbersRef}>
              <InfiniteScroll
                pageStart={0}
                loadMore={loadMoreUsers}
                hasMore={hasMore}
                loader={
                  isLoadingActive && (
                    <LoadingSpinner
                      type="small"
                      relative
                      customClassName="without-background-transparent"
                    />
                  )
                }
                threshold={60}
                initialLoad={false}
                useWindow={false}
              >
                {listingLiveAgentChats()}
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidenavInner;
